// FA5 JS file found at: http://bit.ly/2QyZ7SP
["/apps/websites/shared/bundle/ruby/3.3.0/gems/font_awesome5_rails-1.5.0", "app", "assets", "javascripts", "all.min.js"]
import "/apps/websites/shared/bundle/ruby/3.3.0/gems/font_awesome5_rails-1.5.0/app/assets/javascripts/all.min.js"

FontAwesome.config.mutateApproach = 'sync'; // fix blink problem with turbolinks
